import Component from '@glimmer/component';

import { service } from '@ember/service';

import SearchTerm from 'rise-ui/components/search-term.gjs';

export default class TimeSeriesSearchTermComponent extends Component {
  @service('time-series/search') search;

  <template>
    <SearchTerm
      @route={{this.search.linkToCommit}}
      @placeholder="Search Locations"
      @value={{this.search.editedTerm}}
      @refresh={{this.search.isDirty}}
      @loading={{this.search.results.isLoading}}
      @onInput={{this.search.editTerm}}
    />
  </template>
}
